import React, { useEffect, useState } from "react";
import PromosTable from "./PromosTable";
import { useSearchParams } from "react-router-dom";
import usePermissionCheck from "../../../hooks/usePermissionCheck";
import { TableSearch } from "../../../components/common/Tables/DataTableParts";
import { PlusIcon } from "../../../components/common/Icons/Icons";

interface ContainerProps {
  setCreateOpen: any;
  setEditOpen: any;
  setDeleteOpen: any;
  setViewOpen: any;
  setPreviewOpen: any;
  setPromoToModify: any;
}

const PromosContainer: React.FC<ContainerProps> = ({
  setCreateOpen,
  setEditOpen,
  setDeleteOpen,
  setViewOpen,
  setPreviewOpen,
  setPromoToModify,
}) => {
  const { canAccess: canSendPromos } = usePermissionCheck(['can_send_promos', 'can_send_promos_to_all']);
  const [title, setTitle] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setTitle(searchParams.get('title') ?? '');
  }, [searchParams]);

  const handleFilter = () => {
    searchParams.delete('page');
    title === "" ? searchParams.delete('title') : searchParams.set('title', title);
    setSearchParams(searchParams);
  };

  const handleClear = () => {
    searchParams.delete('page');
    setTitle("");
    searchParams.delete('title');
    setSearchParams(searchParams);
  };

  // Title is the only filter, so it's a search box in the toolbar rather than a sidebar
  const toolbar = (
    <>
      {canSendPromos &&
        <button type="button" className="btn btn-sm btn-primary lp-primary-action" onClick={() => setCreateOpen(true)}>
          <PlusIcon/> Create Promo
        </button>}
      <TableSearch
        id="title-search"
        label="Search titles"
        value={title}
        onChange={setTitle}
        onSearch={handleFilter}
        onClear={handleClear}
      />
    </>
  );

  return (
    <PromosTable
      setPromoToModify={setPromoToModify}
      setEditOpen={setEditOpen}
      setDeleteOpen={setDeleteOpen}
      setViewOpen={setViewOpen}
      setPreviewOpen={setPreviewOpen}
      toolbar={toolbar}
    />
  );
};

export default PromosContainer;
